import { Name } from '@wix/ambassador-account-info-server';

import { TRootState } from '../reducers';

export const selectCountryCode = (state: TRootState): string => {
  return state.user.countryCode;
};

export const selectProfileImage = (state: TRootState): string => {
  return state.user.profileImage;
};

export const selectUserId = (state: TRootState): string => {
  return state.user.id;
};

export const selectUserName = (state: TRootState): Name | undefined => {
  return state.user.name;
};
